// Add lodash/underscore like functions here. Do not add the lodash/underscore package.
// Some pages in the monolith inject lodash in a manner that overrides any js integration.

export const uniq = (arr) => [...new Set(arr)];

export const merge = (to, from) => {
  Object.keys(from).forEach((key) => {
    const value = from[key];
    if (Object.prototype.toString.call(value) === '[object Object]') {
      to[key] = merge(to[key] || {}, value);
    } else {
      to[key] = value;
    }
  });
  return to;
};
